export default function DataFormLanding(){
  return(
    <div>
      Data Form (for documents or projects) landing page coming soon! 
    </div>
  );
}